export default __webpack_public_path__ + "static/fasset-banner-451d00fb141918f4b14faea9cf62a620.webp";